import { supabase } from './supabase';

const ORG_ID = process.env.REACT_APP_ORG ?? 'fcp-pilot';

// Fetch all submissions for this org, newest first.
export async function loadEngagement(orgId) {
  if (!supabase) return [];
  try {
    const { data, error } = await supabase
      .from('community_engagement')
      .select('*')
      .eq('org_id', orgId ?? ORG_ID)
      .order('created_at', { ascending: false });
    if (error) return [];
    return data ?? [];
  } catch (_) {
    return [];
  }
}

// Insert a new submission.
// If Supabase is not configured, returns a local-only record so the UI
// can complete the full flow (pin appears on map until refresh).
export async function saveEngagement(orgId, payload) {
  if (!supabase) {
    return {
      id: `local-${Date.now()}`,
      org_id: orgId ?? ORG_ID,
      ...payload,
      created_at: new Date().toISOString()
    };
  }
  const { data, error } = await supabase
    .from('community_engagement')
    .insert({ org_id: orgId ?? ORG_ID, ...payload })
    .select()
    .single();
  if (error) throw new Error(error.message);
  return data;
}
